import React from 'react';
import Slider from 'react-slick';
import LoginFooter from './LoginFooter';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { LOGIN_SLIDER } from '../constants/loginSliderConstant';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

const LoginCarousel = () => <div className="login-content">
  <div className="login-inner">
    <h1>Welcome to IHX</h1>
    <p style={{ marginTop: '0' }}>
      An industry leading Hospital management platform.
            </p>
    <div className="slider">
      <Slider {...settings}>
        {
          LOGIN_SLIDER.map((slider, index) => <div className="slider-item" key={index}>
            <div>
              <h3>{slider.heading}</h3>
              <p>{slider.description}</p>
            </div>
            <img src={slider.imgSrc} alt={slider.heading} />
          </div>)
        }
      </Slider>
      <div className="line" />
    </div>
  </div>
  <div className="desk__login-footer">
    <LoginFooter/>
  </div>
</div>;

export default LoginCarousel;
